var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.206v15.206H0z",
    fill: "#f25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 0H32v15.206H16.794z",
    fill: "#7fba00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.794h15.206V32H0z",
    fill: "#00a4ef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 16.794H32V32H16.794z",
    fill: "#ffb900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.6cd6b679e49d2fe697ed0d56aa1d8fa6.svg";
export { ForwardRef as ReactComponent };